import { ScopeType } from "sockapi/scope-types";
import {
  useScopeStateResolvable,
  useGlobalScopeState,
} from "stores/ScopeStateStore";
import { Spinner } from "components/Loading";
import {
  CannedHintDisplayType,
  CannedHintDisplay,
} from "components/PuzzlePage/HintsDisplay";

function AdminCannedHintsDisplay(props: { puzName: string; teamId: string }) {
  const { puzName, teamId } = props;
  const huntAdminScopeState = useGlobalScopeState(ScopeType.HUNT_ADMIN);
  const teamCannedHintsScopeState = useScopeStateResolvable(
    ScopeType.TEAM_CANNED_HINTS,
    { teamId }
  );

  if (huntAdminScopeState === null || teamCannedHintsScopeState === null)
    return <Spinner inline={true} />;
  const { numCannedHints } = huntAdminScopeState;
  const cannedHints = teamCannedHintsScopeState.cannedHints[puzName] ?? {
    numTotal: 0,
    numOpened: 0,
  };

  return (numCannedHints[puzName] ?? 0) <= 0 ? (
    <>There are no canned hints for this puzzle.</>
  ) : (
    <>
      {Array.from(Array(numCannedHints[puzName]).keys()).map((i) => (
        <CannedHintDisplay
          key={i}
          puzName={puzName}
          index={i}
          teamId={teamId}
          displayType={
            i < cannedHints.numOpened
              ? CannedHintDisplayType.OPENED
              : i < cannedHints.numTotal
                ? CannedHintDisplayType.ADMIN_UNOPENED
                : CannedHintDisplayType.ADMIN_LOCKED
          }
          spoiler={false}
        />
      ))}
    </>
  );
}

export default AdminCannedHintsDisplay;
